import { render } from "./BackerCenterUpdateFeedSection.vue?vue&type=template&id=34ba5c04"
import script from "./BackerCenterUpdateFeedSection.vue?vue&type=script&lang=js"
export * from "./BackerCenterUpdateFeedSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__